import React from 'react';
import PropTypes from 'prop-types';
import ReactHtmlParser from 'react-html-parser';

import {
  ErrorContainer,
  ErrorMessage,
  ErrorIcon,
} from './styles';

const Error = ({ message }) => (
  <ErrorContainer>
    <ErrorIcon />
    <ErrorMessage>
      {ReactHtmlParser(message)}
    </ErrorMessage>
  </ErrorContainer>
);

Error.propTypes = {
  message: PropTypes.string.isRequired,
};

export default Error;
